module.exports = __webpack_public_path__ + "img/R.547a5b69.jpeg";